<template>
  <default-dialog ref="dialog" @hide="onDialogHide" class="uplift">
    <lottie-player
      :src="JSON.stringify(require('@/assets/animations/happy-smiley.json'))"
      style="width: 88px; height: 88px;"
      autoplay/>
    <div class="r-image-headline well-done">כל הכבוד!</div>
    <div class="r-text-regular text">
      היינו חייבים לעצור שנייה כדי לומר לך כל
      הכבוד! בחרת לעשות היום משהו ממש טוב
      בשביל העתיד שלך, זה לא מובן מאליו.
    </div>
    <dialog-button label="איזה כיף! אפשר להמשיך" @click="okAndHide"/>
  </default-dialog>
</template>

<script>
import GlobalDialog from '@/components/base/GlobalDialog';
import DefaultDialog from '@/components/styled/DefaultDialog';
import TrackedPage from '@/mixins/TrackedPage';
import DialogButton from '@/components/styled/DialogButton';

export default {
  name: 'Uplift',
  components: { DialogButton, DefaultDialog },
  mixins: [GlobalDialog, TrackedPage],
  props: {
    firstName: {
      type: String,
      required: true,
    },
  },
  methods: {
    onCancelClick() {
      this.hide();
    },
  },
};
</script>

<style scoped lang="scss">

.well-done {
  margin: 20px 0;
}

.text {
  margin-bottom: 48px;
}

</style>
